import { Routes, Route, Navigate } from 'react-router-dom';
import { ProjectScope } from '../../components/ProjectScope';
import { Dashboard } from './Dashboard';
import { Itps, ItpDetail } from './Itps';
import { Ncrs, NcrDetail } from './Ncrs';

export function QaRoutes() {
  return (
    <ProjectScope
      storageKey="munin.qa.project"
      emptyBody="Quality management menggantung pada sebuah proyek dan aktivitasnya. Buat proyek lebih dulu."
    >
      {(projectId) => (
        <Routes>
          <Route path="/" element={<Dashboard projectId={projectId} />} />
          <Route path="/itps" element={<Itps projectId={projectId} />} />
          <Route path="/itps/:id" element={<ItpDetail />} />
          <Route path="/ncrs" element={<Ncrs projectId={projectId} />} />
          <Route path="/ncrs/:id" element={<NcrDetail />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </ProjectScope>
  );
}
